<template>
    <v-menu v-model="dateFilterPicker" :close-on-content-click="false" transition="scale-transition" min-width="290px">
        <template v-slot:activator="{props}">
            <v-text-field
                :model-value="$filters.dateFormat(dateFilter)"
                :label="$t('date')"
                clearable
                readonly
                bg-color="white"
                :outlined="outlined"
                prepend-inner-icon="mdi-calendar"
                hide-details
                density="compact"
                v-bind="props"
                @click:clear="clearDate"
            />
        </template>
        <v-date-picker
            v-model="dateObj"
            :allowed-dates="datesForFilter"
            :events="datesForFilter"
            hide-header
            :min="minDate"
            event-color="green-lighten-1"
            @update:model-value="dateFilterPicker = false"
        />
    </v-menu>
</template>

<script lang="ts">
    import {Component, Prop, VModel, Vue} from 'vue-facing-decorator'

    @Component
    export class DateFilterSearch extends Vue {
        @VModel() dateFilter
        @Prop({required: true}) datesForFilter
        @Prop({default: false, type: Boolean}) outlined

        dateFilterPicker = false

        clearDate() {
            this.dateFilter = null
        }

        get dateObj() {
            return this.$dateFns.parseISO(this.dateFilter)
        }

        set dateObj(date: Date) {
            this.dateFilter = this.$dateFns.format(date)
        }

        get firstDayOfWeekByLocale() {
            return this.$dateFns.localeOptions[this.$i18n.locale].weekStartsOn
        }

        get minDate() {
            if (!this.datesForFilter?.length) return this.$dateFns.format(new Date())
            return this.$dateFns.format(this.$dateFns.min(this.datesForFilter.map(date => new Date(date))))
        }
    }

    export default DateFilterSearch
</script>
